import { createAction, createApiAction } from '@saucelabs/sl-util-redux';
import { api as userApi } from '@saucelabs/sl-module-user';

import * as types from './types';

export const cleanup = createAction(types.CLEANUP);
export const initialize = createAction(types.INITIALIZE);
export const putUserInStore = createAction(types.USER_GET.SUCCESS);

export const getRestoUser = createApiAction(
  types.USER_GET_RESTO,
  userApi.getRestoUser,
);
